<script setup>
import TabContainer from "@/components/global-themed/tabs/TabContainer.vue";
import TabItem from "@/components/global-themed/tabs/TabItem.vue";
import {computed, ref} from "vue";
import CountryViewsTable from "@/components/reporting/partials/CountryViewsTable.vue";
import CityViewsTable from "@/components/reporting/partials/CityViewsTable.vue";
import SourceGA from "@/components/reporting/partials/SourceGA.vue";
import {useStore} from "vuex";

const activeTab = ref('country');

const store = useStore();

const loading = computed(() => store.getters['traffic/loading']);

</script>

<template>
  <div class="tw-flex tw-flex-col">
    <h3 class="tw-text-xl tw-text-font-primary tw-font-bold tw-font-sans tw-mb-6">
      Top Locations
    </h3>

    <div class="tw-border-2 tw-rounded-lg tw-grow-1 tw-h-full">
      <TabContainer
        v-if="!loading"
        class="tw-m-8 tw-mb-2"
      >
        <TabItem
          :active="activeTab === 'country'"
          class="tw-gap-2 tw-justify-center"
          @click="activeTab = 'country'"
        >
          <svg-vue
            icon="icons/country"
            class="tw-w-6 tw-h-6"
          />
          <span>Country</span>
        </TabItem>
        <TabItem
          :active="activeTab === 'city'"
          class="tw-gap-2 tw-justify-center"
          @click="activeTab = 'city'"
        >
          <svg-vue
            icon="icons/city"
            class="tw-w-6 tw-h-6"
          />
          <span>City</span>
        </TabItem>
      </TabContainer>

      <div v-if="!loading">
        <CountryViewsTable v-if="activeTab === 'country'" />
        <CityViewsTable v-if="activeTab === 'city'" />
      </div>

      <SourceGA class="tw-pt-2 tw-pb-2 tw-px-4" />
    </div>
  </div>
</template>